export default {
  'notifications.list.createNotifications': 'Criar Notificação',
  'notifications.table.title': 'Título',
  'notifications.table.message': 'Mensagem',
  'notifications.table.DateAndTime': 'Data e Hora',
  'notifications.table.actions': 'Ações',
  'notifications.table.actions.markAsRead': 'Marcar como lido',

  'notifications.markAsRead.title':
    'Deseja realmente marcar como lido essa notificação?',
  'notifications.markAsRead.description':
    'Ao marcar como lido, não será possivel reverter',

  'notifications.success.title': 'Sucesso!',
  'notifications.success.description': 'Notificação marcada como lida',

  'notifications.form.date': 'Data',
  'notifications.form.message': 'Mensagem',
  'notifications.form.title': 'Título',
  'notifications.form.users': 'Usuários',
  'notifications.form.groupUsers': 'Grupo de Usuários',

  'notification.workOrders.lgpd.change.title': 'Salvo com sucesso!',
  'notification.workOrders.lgpd.change.description':
    'O Termo LGPD pode ser personalizado nas configurações de empresa.',
  'notification.workOrders.lgpd.information':
    'As configurações de lembrete e consentimentos sobre a LGPD podem ser alteradas na aba de clientes.',
};
